import { throttle } from 'lodash-es';
import { useEffect, useMemo, useState } from 'react';
/**
 * Mirrors `value`, updating at most once per `waitMs` with lodash `throttle`
 * leading and trailing edges.
 */
export const useThrottledState = (value, waitMs) => {
    const [throttled, setThrottled] = useState(value);
    const throttledSet = useMemo(() => throttle(setThrottled, waitMs), [waitMs]);
    useEffect(() => {
        throttledSet(value);
    }, [value, throttledSet]);
    return throttled;
};
//# sourceMappingURL=useThrottledState.js.map